const RatingOnboardingIllustration = () => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="257"
      viewBox="0 0 273 257"
      width="273"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#rating-onboarding-clip-back-right)">
        <rect
          fill="#ECEAE0"
          height="210"
          rx="18"
          transform="rotate(-7 68.3027 24)"
          width="180"
          x="68.3027"
          y="24"
        />
        <path
          d="M70.4964 41.8658C69.2849 31.9988 76.3015 23.0179 86.1686 21.8064L229.095 4.25717C238.962 3.04565 247.943 10.0623 249.155 19.9294L263.535 137.05L84.877 158.986L70.4964 41.8658Z"
          fill="#E0DED3"
        />
        <rect
          fill="#DCDAD0"
          height="11"
          rx="5.5"
          transform="rotate(-7 104.693 172.673)"
          width="100"
          x="104.693"
          y="172.673"
        />
      </g>
      <g clipPath="url(#rating-onboarding-clip-back-left)">
        <rect
          fill="#ECEAE0"
          height="210"
          rx="18"
          transform="rotate(5 18.3027 32)"
          width="180"
          x="18.3027"
          y="32"
        />
        <path
          d="M16.7339 49.9315C17.6004 40.0282 26.3309 32.7024 36.2342 33.5688L179.686 46.1192C189.59 46.9857 196.915 55.7162 196.049 65.6195L185.765 183.171L6.44955 167.482L16.7339 49.9315Z"
          fill="#E0DED3"
        />
        <rect
          fill="#DCDAD0"
          height="11"
          rx="5.5"
          transform="rotate(5 22.9866 184.99)"
          width="100"
          x="22.9866"
          y="184.99"
        />
      </g>
      <g filter="url(#rating-onboarding-front-shadow)">
        <g clipPath="url(#rating-onboarding-clip-front)">
          <rect
            fill="white"
            height="222"
            rx="18"
            width="190"
            x="30.3027"
            y="10"
          />
          <path
            d="M30.3027 28C30.3027 18.0589 38.3616 10 48.3027 10H202.303C212.244 10 220.303 18.0589 220.303 28V154H30.3027V28Z"
            fill="#B7C6B1"
          />
          <circle cx="125.303" cy="82" fill="white" r="47" />
          <circle cx="125.303" cy="82" fill="#D98E4A" r="31" />
          <rect
            fill="#DCDAD0"
            height="13"
            rx="6.5"
            width="124"
            x="48.3027"
            y="172"
          />
          <rect
            fill="#DCDAD0"
            height="10"
            rx="5"
            width="78"
            x="48.3027"
            y="196"
          />
        </g>
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="254"
          id="rating-onboarding-front-shadow"
          width="222"
          x="14.3027"
          y="0"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.1 0 0 0 0 0.12 0 0 0 0 0.1 0 0 0 0.1 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            mode="normal"
            result="shape"
          />
        </filter>
        <clipPath id="rating-onboarding-clip-back-right">
          <rect
            fill="white"
            height="210"
            rx="18"
            transform="rotate(-7 68.3027 24)"
            width="180"
            x="68.3027"
            y="24"
          />
        </clipPath>
        <clipPath id="rating-onboarding-clip-back-left">
          <rect
            fill="white"
            height="210"
            rx="18"
            transform="rotate(5 18.3027 32)"
            width="180"
            x="18.3027"
            y="32"
          />
        </clipPath>
        <clipPath id="rating-onboarding-clip-front">
          <rect
            fill="white"
            height="222"
            rx="18"
            width="190"
            x="30.3027"
            y="10"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RatingOnboardingIllustration
